import PropTypes from 'prop-types';
import style from './selectable-card.module.scss';

// Tappable card for picking one option from a small set. The whole
// card is the click target (not just a tiny switch) and the selection
// state is conveyed by both a ring-around-card AND a filled check
// bubble — redundancy improves clarity for sighted + color-blind
// users.
//
// Used for both:
//   - Checkbox semantics (multiple can be selected — e.g. delivery
//     methods on Review: Print + Wallet)
//   - Radio semantics (exactly one — e.g. Offer Type on Reward:
//     Fixed OR Percentage)
//
// a11y: renders as a `<button>` with `aria-pressed`. That's the
// simplest correct pattern for toggle behavior and it's also
// acceptable for a two-card radio set — GitHub, Vercel and Linear
// all use this idiom for tab/segmented pickers.
function SelectableCard({ icon, title, subtitle, selected, onToggle }) {
  return (
    <button
      type="button"
      className={`${style.card} ${selected ? style.selected : ''}`}
      aria-pressed={selected}
      onClick={onToggle}
    >
      <span className={style.iconTile} aria-hidden="true">
        {icon}
      </span>
      <span className={style.body}>
        <span className={style.title}>{title}</span>
        {subtitle && <span className={style.subtitle}>{subtitle}</span>}
      </span>
      <span className={style.check} aria-hidden="true">
        <svg viewBox="0 0 12 12" fill="none">
          <path
            d="M2.5 6.5L5 9L9.5 3.5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
}

SelectableCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SelectableCard;
